import { render, staticRenderFns } from "./TicketForwardingLog.vue?vue&type=template&id=15dc0365&scoped=true&"
import script from "./TicketForwardingLog.vue?vue&type=script&lang=js&"
export * from "./TicketForwardingLog.vue?vue&type=script&lang=js&"
import style0 from "./TicketForwardingLog.vue?vue&type=style&index=0&id=15dc0365&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dc0365",
  null
  
)

export default component.exports